import SEO from "@/components/SEO";
import PageHero from "@/components/PageHero";
import { Reveal, Eyebrow } from "@/components/Reveal";

const SECTIONS = [
  {
    id: "privacy-policy",
    title: "Privacy Policy",
    body: [
      "Delhi STD Clinic collects only the information necessary to arrange and provide your consultation — typically your name, age, contact number and the concern you choose to share when booking.",
      "This information is used solely to schedule, confirm and conduct your appointment and any related follow-up care. It is handled with professional medical confidentiality and is not sold, rented or shared with third parties for marketing purposes.",
      "Consultation and medical information is accessible only as needed for your care. We communicate with you only through the contact details you provide to us.",
      "As a medical practice, certain records must be maintained in accordance with applicable law and medical ethics. We therefore do not claim that consultations are 'anonymous' or that 'no records are kept' — instead, we commit to genuine, professional confidentiality.",
      "You may contact the clinic at any time to ask questions about the information you have shared with us.",
    ],
  },
  {
    id: "terms",
    title: "Terms & Conditions",
    body: [
      "This website provides general information about the services of Delhi STD Clinic and Dr. Ankur Lal, and a facility to request appointments. Use of the website does not create a doctor–patient relationship; such a relationship begins only with a consultation.",
      "Appointment requests submitted through this website are requests, not confirmed appointments. Your appointment time is confirmed when the clinic contacts you.",
      "Content on this website is intended for adults seeking sexual-health information and care. By using the booking facility, you confirm that the contact details you provide are your own and that the clinic may contact you on them regarding your appointment.",
      "The clinic name, content and design of this website may not be reproduced without permission.",
    ],
  },
  {
    id: "medical-disclaimer",
    title: "Medical Disclaimer",
    body: [
      "The information on this website is general medical information for educational purposes. It is not a substitute for individualized medical advice, diagnosis or treatment, and it may not apply to your specific situation.",
      "No content on this website guarantees any treatment outcome. Medical care at Delhi STD Clinic is based on individual clinical assessment and established medical guidelines.",
      "If you believe you may need HIV PEP, treat it as time-sensitive: seek medical advice as soon as possible after a potential exposure — PEP is generally not recommended after 72 hours.",
      "If you are experiencing a medical emergency, please visit the nearest emergency department rather than relying on this website.",
    ],
  },
  {
    id: "cancellation-refund",
    title: "Cancellation & Refund Policy",
    body: [
      "If you need to cancel or reschedule your appointment, please inform the clinic as early as possible by phone or WhatsApp so the slot can be offered to another patient.",
      "Where a consultation fee has been paid in advance and the appointment is cancelled with reasonable notice before the consultation, a refund or rescheduling will be arranged. Consultations that have already taken place are not refundable.",
      "For any billing or refund question, please contact the clinic directly — every request is handled individually and fairly.",
    ],
  },
];

const Legal = () => (
  <>
    <SEO
      title="Privacy Policy, Terms & Medical Disclaimer | Delhi STD Clinic"
      description="Privacy policy, terms & conditions, medical disclaimer and cancellation/refund policy for Delhi STD Clinic — Dr. Ankur Lal, New Delhi."
      path="/privacy-policy"
    />
    <PageHero
      eyebrow="Legal"
      title="Privacy Policy, Terms & Disclaimers"
      intro="Plain-language policies that reflect how the clinic actually practices: honest, private and professional."
    />

    <section className="py-14 sm:py-20" data-testid="legal-sections">
      <div className="max-w-3xl mx-auto px-5 sm:px-8 space-y-16">
        {SECTIONS.map((s, i) => (
          <Reveal key={s.id} delay={0.03}>
            <section id={s.id} data-testid={`legal-${s.id}`} className="scroll-mt-28">
              <Eyebrow>{String(i + 1).padStart(2, "0")}</Eyebrow>
              <h2 className="mt-3 font-serif text-3xl font-semibold text-slate-950">{s.title}</h2>
              <div className="mt-5 space-y-4">
                {s.body.map((p, j) => (
                  <p key={j} className="text-slate-600 leading-relaxed text-[15px]">
                    {p}
                  </p>
                ))}
              </div>
            </section>
          </Reveal>
        ))}
        <p className="text-xs text-slate-400">Last updated: July 2026</p>
      </div>
    </section>
  </>
);

export default Legal;
